import { Button } from '@workingclock/ui';
import { useTranslation } from 'react-i18next';

import { appStoreUrl } from '../../lib/env';

/** Apple's logo, flattened to one colour so it follows the button's text colour. */
function AppleIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden className="h-4 w-4 fill-current">
      <path d="M17.05 12.54c-.03-2.85 2.33-4.22 2.43-4.29-1.32-1.94-3.38-2.2-4.12-2.23-1.75-.18-3.42 1.03-4.31 1.03-.89 0-2.26-1.01-3.72-.98-1.91.03-3.68 1.11-4.66 2.82-1.99 3.45-.51 8.55 1.43 11.35.95 1.37 2.08 2.91 3.56 2.85 1.43-.06 1.97-.92 3.7-.92 1.73 0 2.21.92 3.72.89 1.54-.03 2.51-1.39 3.45-2.77 1.09-1.59 1.54-3.13 1.56-3.21-.03-.02-2.99-1.15-3.04-4.54ZM14.22 4.17c.79-.96 1.32-2.28 1.17-3.6-1.13.05-2.51.75-3.32 1.71-.73.84-1.37 2.19-1.2 3.48 1.26.1 2.55-.64 3.35-1.59Z" />
    </svg>
  );
}

export function AppStoreButton({ className }: { className?: string }) {
  const { t } = useTranslation('marketing');

  return (
    <Button variant="secondary" asChild className={className}>
      <a href={appStoreUrl} target="_blank" rel="noopener noreferrer">
        <AppleIcon />
        {t('stores.appStore')}
      </a>
    </Button>
  );
}
